import React from "react";
import { CentralIconBase, type CentralIconBaseProps } from "../CentralIconBase";

export const IconPaperPlaneTopRight: React.NamedExoticComponent<CentralIconBaseProps> = React.memo(React.forwardRef<SVGSVGElement, CentralIconBaseProps>((props, ref) => {
  return <CentralIconBase {...props} ref={ref} ariaLabel={"paper-plane-top-right, send"} maskId="square-filled-radius-0-stroke-1-IconPaperPlaneTopRight"><path d="M8.26003 10.8764L0.84375 3H23.3724L11.824 22.773L8.75259 11.7467L15.681 7.87931L15.1936 7.00613L8.26003 10.8764Z" fill="currentColor"/></CentralIconBase>;
}));

export default IconPaperPlaneTopRight;
